require('normalize.css');
require('styles/App.scss');
require('bootstrap-sass/assets/stylesheets/_bootstrap.scss');
require('styles/main.scss');
require('babel-polyfill');
import colours from 'styles/Colours.scss';

import 'core-js/fn/object/assign';
import React from 'react';
import ReactDOM from 'react-dom';
import { Redirect, Router, Route, Link, browserHistory } from 'react-router'
import { Navbar, Nav, NavItem, NavDropdown } from 'react-bootstrap'

import ClaimUpload from './components/ClaimUpload'
import ClaimUploadStudent from './components/ClaimUploadStudent'
import Landing from './components/Landing'
import Sources from './components/Sources'
import Report from './components/Report'
import User from './components/User'
import CreateUser from './components/CreateUser'
import ContactUs from './components/ContactUs'
import UserProfile from './components/UserProfile'
import Search from './components/Search'
import Quote from './components/Quote'
import Claim from './components/Claim'
import SearchUser from './components/SearchUser'
import SearchClaim from './components/SearchClaim'
import Manage from './components/Manage'
import Login from './components/Login'
import MicrositeLogin from './components/MicrositeLogin'
import Reset from './components/Reset'
import Upload from './components/Upload'
import Regenerate from './components/Regenerate'
import Commissions from './components/Commissions'
import Dropbox from './components/Dropbox'
import ProductCategories from './components/ProductCategories'
import AgentProducts from './components/AgentProducts'
import ResourceCentre from './components/ResourceCentre'
import ApplicationForm from './components/ApplicationForm'
import Documents from './components/Documents'
import BulkUploadList from './components/BulkUploadList';
import UploadDetails from './components/UploadDetails';
import PPNSearch from './components/PPNSearch';
import MemberPortal from './components/MemberPortal';
import HowToSubmitClaim from './components/HowToSubmitClaim';
import Icon from 'react-fa'

import { t, setLocale, setLang } from './helpers/translate'
import * as access from './helpers/access'
import { setColour } from './helpers/style'
import TripCalculator from './components/TripCalculator';

let config = require('config');

const App = React.createClass({

  setCssColours(type) {
    if (access.isLoggedIn()) {
      return setColour(this.getUserColour(type), type);
    }
    setColour(this.getDomainColour(type), type);
  },

  setColour(colour, type) {
    const root = document.documentElement;
    root.style.setProperty(`--client-${type}`, colour);
  },

  getUserColour(type) {
    return colours[`${sessionStorage.getItem('org')}${type}`];
  },

  getDomainColour(type) {
    return colours[`${access.getPortal()}${type}`];
  },

  showLanguageSelector() {
    return location.hostname == 'www.mshagents.com' ? false : !(access.checkOrg('ingle') && access.isAgent())
  },

  getIngleagentsLink(type) {
    return `${config.default.ingle_international_api}/login/en/travel-insurance/${type}/${sessionStorage.getItem('csr_token')}`;
  },

  render() {
    access.updateVersion();

    if (sessionStorage.getItem('microsite_colour')) {
      setColour(sessionStorage.getItem('microsite_colour'), 'primary');
      setColour(sessionStorage.getItem('microsite_colour'), 'secondary');
    } else {
      this.setCssColours('primary');
      this.setCssColours('secondary');
    }

    const pages = ["claim_upload", "ppn_search", "login", "reset_password", "member_portal", "how_to_submit_claim"];
    const isLoggedIn = access.isLoggedIn();
    const isAllowedPage = pages.some(page => window.location.pathname.includes(page));

    if (!isAllowedPage && !isLoggedIn) {
      access.signOut();
    }

    return (<div className={sessionStorage.getItem('org')}>
      {!sessionStorage.getItem('hide_navbar') && <Navbar className="navbar-static-top" fluid={true}>
        <Nav pullLeft>
          {access.isLoggedIn() &&
            <NavDropdown title={<span><Icon name="bars" size="lg" /> {t('Menu')}</span>} id="collapsible-nav-dropdown" data-toggle="dropdown-toggle">
              {
                !((access.isAgent() || access.isViewonly()) && access.checkOrg('ingle')) &&
                <NavItem className='mouse-pointer'
                  onClick={
                    () => { if (access.isLoggedIn()) { browserHistory.push('/products'); } }
                  }
                  eventKey={1}>
                  <Icon name="shopping-cart" size="lg" /> {t('Products')}
                </NavItem>
              }
              {
                (access.isAdmin() || access.isSchoolAdmin()) && !access.checkOrg('msg') &&
                <NavItem className='mouse-pointer' onClick={() => window.location = '/reporting'} eventKey={1}>
                  <Icon name="file-excel-o" size="lg" /> {t('Reporting')}
                </NavItem>
              }
              {
                (access.isAgent('ingle') || access.isGroupAdmin() || access.isAdmin() || access.isMasterAdmin()) && (access.checkOrg('ingle') || access.checkOrg('msg')) &&
                <NavItem className='mouse-pointer' onClick={() => window.location = '/commissions'} eventKey={1}>
                  <Icon name="money" size="lg" /> {t('Commissions')}
                </NavItem>
              }
              {
                (access.isSuperAdmin() || access.isSchoolAdmin() || access.isAdmin() || access.isMasterAdmin()) && access.checkOrg('ingle') &&
                <NavItem className='mouse-pointer' onClick={() => window.location = '/file_exchange'} eventKey={1}>
                  <Icon name="dropbox" size="lg" /> {t('File Exchange')}
                </NavItem>
              }
              {
                (access.canViewClaims() && access.checkOrg('ingle')) &&
                <NavItem className='mouse-pointer' onClick={() => window.location = '/claim_management'} eventKey={1}>
                  <Icon name="search" size="lg" /> {t('Claims')}
                </NavItem>
              }
              {
                access.isMasterAdmin() &&
                <NavItem className='mouse-pointer' onClick={() => window.location = '/user_management'} eventKey={1}>
                  <Icon name="users" size="lg" /> {t('Users')}
                </NavItem>
              }
              {
                access.isMasterAdmin() &&
                <NavItem className='mouse-pointer' onClick={() => window.location = '/create_user'} eventKey={1}>
                  <Icon name="user" size="lg" /> {t('Create User')}
                </NavItem>
              }
              {
                access.isAgent('ingle') &&
                <NavItem className='mouse-pointer' onClick={() => window.location = '/products'} eventKey={1}>
                  <Icon name="list" size="lg" /> {t('Sell Now')}
                </NavItem>
              }
              {
                access.isAgent('ingle') &&
                <NavItem className='mouse-pointer' onClick={() => browserHistory.push('/resource_centre')} eventKey={1}>
                  <Icon name="info-circle" size="lg" /> {t('Resource Centre')}
                </NavItem>
              }
              {
                access.isAgent('ingle') &&
                <NavItem className='mouse-pointer' onClick={() => window.location = '/contact_us'} eventKey={1}>
                  <Icon name="phone" size="lg" /> {t('Contact Us')}
                </NavItem>
              }
              {
                !access.checkOrg('msg') &&
                <NavItem className='mouse-pointer' onClick={() => window.location = '/documents'} eventKey={1}>
                  <Icon name="files-o" size="lg" /> {t('Documents')}
                </NavItem>
              }
              {
                (access.isSuperAdmin() || access.isAdmin() || access.isMasterAdmin()) && access.checkOrg('ingle') &&
                <NavItem className='mouse-pointer' onClick={() => window.location = '/bulkuploadlist'} eventKey={1}>
                  <Icon name="upload" size="lg" /> {t('Bulk Upload History')}
                </NavItem>
              }
              {
                (access.isSuperAdmin() || access.isAdmin() || access.isMasterAdmin()) && access.checkOrg('ingle') &&
                <NavItem className='mouse-pointer' onClick={() => window.location = '/reports/universal'} eventKey={1}>
                  <Icon name="download" size="lg" /> {t('Reports History')}
                </NavItem>
              }
              {
                <NavItem className='mouse-pointer' onClick={() => window.location = '/trip_calculator'} eventKey={1}>
                  <Icon name="calculator" size="lg" /> {t('Trip Calculator')}
                </NavItem>
              }
            </NavDropdown>
          }
          <NavItem className='mouse-pointer' onClick={() => window.location = (access.isLoggedIn() ? '/home' : '/login')} eventKey={1}>
            <Icon name="home" size="lg" /> {t('Home')}
          </NavItem>
          {
            access.isLoggedIn() &&
            <NavItem className='mouse-pointer' onClick={() => window.location = '/search/universal'} eventKey={1}>
              <Icon name="search" size="lg" /> {t('Policies')}
            </NavItem>
          }
          {
            access.isLoggedIn() && !(access.isSchoolAdmin() || access.isViewonly()) &&
            <NavItem className='mouse-pointer' onClick={() => window.location = '/quotes/universal'} eventKey={1}>
              <Icon name="search" size="lg" /> {t('Quotes')}
            </NavItem>
          }
        </Nav>
        <Navbar.Collapse>
          <Nav pullRight>
            {
              access.isSchoolAdmin() && access.checkOrg('ingle') &&
              <NavItem className='mouse-pointer' onClick={() => window.open('http://docs.mshtravel.com/docs/Microsites/StudyInsured+School+Admin+Dashboard+Manual.pdf')} eventKey={1}>
                <Icon name="info-circle" size="lg" />
              </NavItem>
            }
            {
              access.isLoggedIn() &&
              <NavDropdown title={<span><Icon name="cog" size="lg" /> {t('Settings')}</span>} id="collasible-nav-dropdown">
                {
                  access.isLoggedIn() &&
                  <NavItem className='profile'>
                    <Link
                      className=''
                      to={{
                        state: {
                          userId: sessionStorage.getItem('user_id')
                        },
                        pathname: `/profile`
                      }}
                    ><Icon name="user" size="lg" /> {sessionStorage.getItem('me')}</Link>
                  </NavItem>
                }
                {access.isLoggedIn() && <NavItem onClick={access.signOut} eventKey={1}><Icon name="sign-out" size="lg" /> {t('Sign Out')}</NavItem>}
              </NavDropdown>
            }
            {
              this.showLanguageSelector() &&
              <NavItem className='language-selector'>
                <select
                  value={sessionStorage.getItem('locale')}
                  onChange={(e) => setLang(e)}
                >
                  <option value="en">EN</option>
                  <option value="fr">FR</option>
                </select>
              </NavItem>
            }
          </Nav>
        </Navbar.Collapse>
      </Navbar>}
      {this.props.children}
    </div>)
  }
}
);

ReactDOM.render(
  <Router history={browserHistory}>
    <Redirect from="/" to="/login" />
    <Route path="/" component={App}>
      <Route path="products" component={Sources} />
      <Route path="login" component={Login} />
      <Route path="login/:microsite" component={MicrositeLogin} />
      <Route path="reset_password">
        <Route path=":token" component={Reset} />
      </Route>
      <Route path="quotes">
        <Route path=":source" component={Search} searchType='quote' />
      </Route>
      <Route path="reports">
        <Route path=":source" component={Search} searchType='report' />
      </Route>
      <Route path="search">
        <Route path=":source" component={Search} searchType='applicant' />
      </Route>
      <Route path="user_management" component={SearchUser} searchType='user' />
      <Route path="upload">
        <Route path=":source" component={Upload} />
      </Route>
      <Route path="manage">
        <Route path=":source" component={Manage} />
      </Route>
      <Route path="quote">
        <Route path=":source" component={Quote} />
      </Route>
      <Route path="home" component={Landing} />

      <Route path=":microsite/claim_upload/:lang" component={ClaimUpload} />
      <Route path=":microsite/claim_upload_student/:lang" component={ClaimUploadStudent} />
      <Route path="claim_management" component={SearchUser} searchType='claim' />
      <Route path="claim" component={Claim} />

      <Route path="user" component={User} />
      <Route path="create_user" component={CreateUser} />
      <Route path="profile" component={UserProfile} />
      <Route path="regenerate" component={Regenerate} />
      <Route path="commissions" component={Commissions} />
      <Route path="file_exchange" component={Dropbox} />
      <Route path="reporting" component={Report} />
      <Route path="product_categories" component={ProductCategories} />
      <Route path="agent_products" component={AgentProducts} />
      <Route path="contact_us" component={ContactUs} />
      <Route path="resource_centre" component={ResourceCentre} />
      <Route path="application_form" component={ApplicationForm} />
      <Route path="documents" component={Documents} />
      <Route path="trip_calculator" component={TripCalculator}/>
      <Route path="bulkuploadlist" component={BulkUploadList} searchType='bulkuploadlist' />
      <Route path="uploaddetails" component={UploadDetails} searchType='uploaddetails' />
      <Route path=":microsite/ppn_search/:lang" component={PPNSearch} />
      <Route path=":microsite/member_portal/:lang" component={MemberPortal} />
      <Route path=":microsite/how_to_submit_claim/:lang" component={HowToSubmitClaim} />

    </Route>
  </Router>
  , document.getElementById('app'));



// WEBPACK FOOTER //
// ./src/index.js